import React from 'react';
import Skeleton from 'react-loading-skeleton';
import {
  Row, Col,
} from 'reactstrap';

const SpecialtiesServicesSkeleton = () => (
  <>
    <Row className="mb-3">
      <Col lg={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
          width={250}
        />
        <div className="mb-3 mt-3" style={{ marginLeft: '30px' }}>
          <div>
            <Skeleton
              borderRadius={10}
              baseColor="var(--skeleton-base)"
              highlightColor="var(--skeleton-highlight)"
              height={250}
              // width={500}
            />
          </div>
        </div>
      </Col>
      <Col lg={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
          width={250}
        />
        <div className="mb-3 mt-3" style={{ marginLeft: '30px' }}>
          <div>
            <Skeleton
              borderRadius={10}
              baseColor="var(--skeleton-base)"
              highlightColor="var(--skeleton-highlight)"
              height={250}
              // width={500}
            />
          </div>
        </div>
      </Col>
    </Row>
    <Row className="mb-3">
      <Col lg={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
          width={250}
        />
        <div className="mb-3 mt-3" style={{ marginLeft: '30px' }}>
          <div>
            <Skeleton
              borderRadius={10}
              baseColor="var(--skeleton-base)"
              highlightColor="var(--skeleton-highlight)"
              height={250}
              // width="auto"
            />
          </div>
        </div>
      </Col>
      <Col lg={6}>
        <Skeleton
          borderRadius={10}
          baseColor="var(--skeleton-base)"
          highlightColor="var(--skeleton-highlight)"
          height={40}
          width={250}
        />
        <div className="mb-3 mt-3" style={{ marginLeft: '30px' }}>
          <div>
            <Skeleton
              borderRadius={10}
              baseColor="var(--skeleton-base)"
              highlightColor="var(--skeleton-highlight)"
              height={250}
              // width={500}
            />
          </div>
        </div>
      </Col>
    </Row>
  </>
);

export default SpecialtiesServicesSkeleton;
